import React from 'react';
import { observer, inject } from 'mobx-react';
import DetailLayout from '../detail/DMain';
import DetailButton from '../detail/DetailButton';
import McLayout from './McLayout';
import TabLayout from './TabLayout';
import FieldContent from './FieldContent';
import SystemField from '../cellType/SystemField';
import InsertScanCode from '../cellType/InsertScanCode';
import InsertIframe from '../cellType/InsertIframe';
import WeaWfFinancial from '../../public/wf-financial/index';
import { getAntd, getEcCom, getLabel } from '../../util/convert';
import { Homepage } from '../../asyncComps/Portal';
import * as DetailUtil from '../../util/public/detailUtil';
import * as FormatUtil from '../../util/public/formatUtil';
import * as _ from '../../util/public/common';
import { handWritingHander } from '../../util/signUtil';
import FnaInvoiceIdentify from '../../asyncComps/FnaInvoiceIdentify'

@inject('globalStore', 'layoutStore')
@observer
export default class CellType extends React.Component {
    render() {
        const { Checkbox } = getAntd();
        const { WeaHelpfulTip } = getEcCom();
        const { symbol, cellObj, detailProps, nodeSignProps = {} } = this.props;
        const cellid = cellObj.id;
        const cellMark = symbol + "_" + cellid.replace(",", "_");
        const etype = parseInt(cellObj.etype || 0);
        let evalue = cellObj.evalue;
        const { globalStore, layoutStore } = this.props;
        const { JSComplete, isSourceLayout, commonParam, commonApiParam, urlParams } = globalStore;
        const { iscreate } = commonApiParam;
        const { requestid, workflowid } = commonParam;
        const { cellInfo, detailMap, variableMap } = layoutStore;
        const canEdit = parseInt(commonParam.isviewonly || 0) !== 1 && parseInt(commonParam.isaffirmance || 0) !== 1;
        //节点分组所在行非文本设置无效
        if (nodeSignProps.belong === true && !(etype === 0 || etype === 1 || etype === 4 || etype === 5)) {
            return this.renderDomObj(
                <span dangerouslySetInnerHTML={{ __html: getLabel(528409, "无效单元格，意见分组所在行不支持此类型设置") }}></span>
            );
        }
        if (etype === 0 || etype === 1 || etype === 6 || etype === 24) {    //文本、图片(可能有<br>)
            if (etype === 24)
                evalue = getLabel(15486, "序号");
            if (evalue === "")
                return  this.renderDomObj(<span>{" "}</span>)
            return this.renderDomObj(
                <span dangerouslySetInnerHTML={{ __html: this.convertText(evalue, etype === 24) }}></span>
            );
        } else if (etype === 2 || etype === 3) { //字段名、字段值
            const fieldid = cellObj.field.toString();
            const { fieldAttrMap } = layoutStore;
            if (!fieldAttrMap.has(fieldid))  //模板字段被删除情况
                return this.renderDomObj(<span style={{ display: "none" }}>Field UnExist!</span>);
            const fieldAttr = fieldAttrMap.get(fieldid);
            const isDetail = symbol.indexOf("detail_") > -1 && fieldAttr.isDetail;
            if (etype === 2) {
                const financialCfg = cellObj.financial;
                const fieldLabel = fieldAttr.fieldlabel;
                const fontSize = _.get(cellObj, ["font", "font-size"]) || "9pt";
                if (financialCfg && financialCfg.indexOf("1-") > -1) {     //财务表头
                    const finNum = parseInt(financialCfg.split("-")[1] || "3");
                    return this.renderDomObj(
                        <WeaWfFinancial ecId={`${this && this.props && this.props.ecId || ''}_WeaWfFinancial@q1lval`} type={1} finNum={finNum} label={fieldLabel} className={`finarea_${fieldid}`} fontSize={fontSize} />
                        , "", { height: "100%", width: "100%" });
                } else {
                    if (fieldLabel === "")
                        return this.renderDomObj(<span></span>);
                    return this.renderDomObj(
                        <span dangerouslySetInnerHTML={{ __html: this.convertText(fieldLabel, etype === 24, false) }}></span>
                    );
                }
            } else if (etype === 3) {
                const rowIndex = isDetail ? parseInt(detailProps.rowIndex) : -1;
                const fieldMark = isDetail ? `field${fieldid}_${rowIndex}` : `field${fieldid}`;
                return this.renderDomObj(
                    <FieldContent ecId={`${this && this.props && this.props.ecId || ''}_FieldContent@r045n3`} symbol={symbol} cellObj={cellObj} isDetail={isDetail} rowIndex={rowIndex} />, fieldMark
                );
            }
        } else if (etype === 4) {   //流程意见节点名称
            const nodeid = cellObj.field.toString();
            const { nodeNameInfo, nodeMarkContent } = cellInfo;
            let nodename = "";
            if (nodeSignProps.belong === true) {
                const groupNodeMark = nodeMarkContent[nodeSignProps.cellKey];
                nodename = groupNodeMark && groupNodeMark[nodeSignProps.current].name || "";
            } else {
                nodename = nodeNameInfo[nodeid] || evalue;
            }
            if (nodename === "") return this.renderDomObj(<span></span>);
            return this.renderDomObj(
                <span dangerouslySetInnerHTML={{ __html: this.convertText(nodename) }}></span>
            );
        } else if (etype === 5) { //流转意见

            const { nodeMarkContent } = cellInfo;
            let nodeMark = "";
            if (nodeSignProps.belong === true) {
                const groupNodeMark = nodeMarkContent[nodeSignProps.cellKey];
                nodeMark = groupNodeMark && groupNodeMark[nodeSignProps.current].content || "";
            } else {
                if (isSourceLayout)
                    nodeMark = this.props.nodeMark || "";
                else {
                    nodeMark = nodeMarkContent && nodeMarkContent[cellMark] || "";
                    if (symbol.indexOf("mc_") > -1 && Array.isArray(nodeMark))
                        nodeMark = getLabel(528410, "分组节点意见不能置于多文本布局中，请调整模板设置！");
                }
            }
            const { authStr, authSignatureStr, docViewUrl, isprint, f_weaver_belongto_userid, f_weaver_belongto_usertype } = globalStore.commonParam;
            //替换使相关流程走新的E9链接
            nodeMark = nodeMark.replace(new RegExp("/workflow/request/ViewRequest(ForwardSPA)?\\.jsp\\?", "g"), `/workflow/request/ViewRequestForwardSPA.jsp?authStr=${authStr}&authSignatureStr=${authSignatureStr}&f_weaver_belongto_userid=${f_weaver_belongto_userid}&f_weaver_belongto_usertype=${f_weaver_belongto_usertype}&`);
            nodeMark = nodeMark.replace(new RegExp("/docs/docs/DocDsp\\.jsp\\?", "g"), `${docViewUrl}?authStr=${authStr}&authSignatureStr=${authSignatureStr}&`);
            if (isprint == "1") nodeMark = handWritingHander(nodeMark);//打印时，处理手写签批样式
            return this.renderHtmlText(nodeMark, 5);
        } else if (etype === 7) { //明细
            return this.renderDomObj(<DetailLayout ecId={`${this && this.props && this.props.ecId || ''}_DetailLayout@ry4hmp`} symbol={cellObj.detail} />);
        } else if (etype === 10) { //明细增删按钮
            return this.renderDomObj(<DetailButton ecId={`${this && this.props && this.props.ecId || ''}_DetailButton@xyxazo`} symbol={symbol} />);
        } else if (etype === 11) { //链接
            const { fieldtype, field } = cellObj;
            let url = "";
            url = fieldtype == 1 ? "http://" : url;
            url = fieldtype == 2 ? "https://" : url;
            url = fieldtype == 3 ? "ftp://" : url;
            url = fieldtype == 4 ? "news://" : url;
            url += field;
            return this.renderDomObj(
                <a target="_blank" href={url} dangerouslySetInnerHTML={{ __html: evalue === "" ? "" : this.convertText(evalue) }}></a>
            );
        } else if (etype === 12) { //标签页
            const cellidMark = cellid.replace(",", "_");
            const { variableMap } = layoutStore;
            const showid = variableMap.get(`tabarea_${cellidMark}_showid`) || "";
            return this.renderDomObj(
                <TabLayout ecId={`${this && this.props && this.props.ecId || ''}_TabLayout@6udpjd`} cellMark={cellidMark} tab={cellObj.tab} showid={showid} />
            );
        } else if (etype === 13) { //多内容
            return this.renderDomObj(
                <McLayout ecId={`${this && this.props && this.props.ecId || ''}_McLayout@q0bqjd`} mcMark={cellObj.mcpoint} />
            );
        } else if (etype === 15) {      //门户元素
            const jsonparam = cellObj.jsonparam || {};
            const hpid = jsonparam.hpid || "";
            if (hpid !== "") {
                const trifields = jsonparam && jsonparam.trifields || "";
                let relateformData = {};
                const { fieldAttrMap, mainData } = layoutStore;
                !!trifields && trifields.split(",").map(fieldid => {
                    let fieldValue = "";
                    const _fieldid = fieldid.substring(5);
                    if (fieldAttrMap.has(_fieldid)) {
                        fieldValue = mainData.has(fieldid) ? mainData.get(fieldid).value : "";
                        fieldValue = fieldValue.toString();
                        const fieldAttr = fieldAttrMap.get(_fieldid);
                        if (fieldAttr.htmltype === 1 && fieldAttr.detailtype === "5")
                            fieldValue = fieldValue.replace(/,/g, "");
                    }
                    relateformData[fieldid] = fieldValue;
                });
                return this.renderDomObj(
                    <Homepage ecId={`${this && this.props && this.props.ecId || ''}_Homepage@rdfggz`} hpid={hpid} workflowid={workflowid} requestid={requestid} formData={relateformData} />
                );
            }
        } else if (etype === 16) {     //iframe区域
            const jsonparam = cellObj.jsonparam || {};
            return JSComplete ? <InsertIframe ecId={`${this && this.props && this.props.ecId || ''}_InsertIframe@bcipl2`} jsonparam={jsonparam} /> : <span></span>;
        } else if (etype === 17) {  //扫码区
            const jsonparam = cellObj.jsonparam || {};
            const otherparam = { iscreate: iscreate, isPreView: urlParams.isPreView };
            return JSComplete ? this.renderDomObj(<InsertScanCode ecId={`${this && this.props && this.props.ecId || ''}_InsertScanCode@rk7cyq`} jsonparam={jsonparam} otherparam={otherparam} />) : this.renderDomObj(<span></span>);
        } else if (etype === 18 || etype === 19) {     //合计名称、合计值
            const fieldid = cellObj.field || "";
            const { fieldAttrMap, linkageCfg, variableMap } = layoutStore;
            if (etype === 18) {
                const fieldlabel = fieldAttrMap.get(fieldid).fieldlabel || "";
                return this.renderDomObj(<span>{fieldlabel + "(" + getLabel(358, '合计') + ")"}</span>);
            } else {
                let sumValue = "";
                if (_.has(linkageCfg, ["colCalCfg", fieldid])) {   //设置了合计
                    if (variableMap.has(`sum${fieldid}`))
                        sumValue = variableMap.get(`sum${fieldid}`);
                    else
                        sumValue = "0";
                }
                return this.renderDomObj(<span>{FormatUtil.convertFormatValue_sum(sumValue, fieldid)}</span>);
            }
        } else if (etype === 20) { //明细全选
            const detailObj = detailMap.get(symbol) || {};
            const { attr, currentPageRowArr, dropBtnKey } = detailObj;
            const { isadd, isdelete } = attr;
            let existCheckedRow = false;
            let existUnCheckedRow = false;
            if (canEdit && currentPageRowArr.length > 0 && (isadd === 1 || isdelete === 1)) {
                currentPageRowArr.map(info => {
                    if (existUnCheckedRow || (dropBtnKey === 1 && isdelete !== 1 && parseInt(info.keyid || 0) > 0))     //已有明细禁止删除情况不参与
                        return "";
                    if (info.checked) {
                        existCheckedRow = true;
                    } else {
                        existUnCheckedRow = true;
                    }
                });
            }
            const isDisabled = !(existCheckedRow || existUnCheckedRow);
            return this.renderDomObj(
                <Checkbox ecId={`${this && this.props && this.props.ecId || ''}_Checkbox@mhglgu`} onChange={(e) => {
                    DetailUtil.setAllRowChecked(symbol, e.target.checked)
                }} disabled={isDisabled} checked={existCheckedRow && !existUnCheckedRow} />
            );
        } else if (etype === 21) { //明细单选
            const { rowIndex } = detailProps;
            const detailObj = detailMap.get(symbol) || {};
            const { attr, rowInfo, dropBtnKey } = detailObj;
            const { isdelete } = attr;
            const info = rowInfo.get("row_" + rowIndex);
            const checkProps = { checked: !!info.get("checked") };
            if (dropBtnKey === 1) {   //禁止删除已有明细
                if (!canEdit || (isdelete !== 1 && parseInt(info.get("keyid") || 0) > 0))
                    checkProps["disabled"] = true;
            }
            if (info.get("disableCheck") === true)
                checkProps["disabled"] = true;
            const detailIndex = parseInt(symbol.substring(7)) - 1;
            return this.renderDomObj(<span>
                <Checkbox ecId={`${this && this.props && this.props.ecId || ''}_Checkbox@hj96fz`} onChange={(e) => {
                    DetailUtil.setRowChecked(symbol, rowIndex, e.target.checked)
                }} {...checkProps} />
                <input type="hidden" name={`check_node_${detailIndex}`} value={rowIndex} />
            </span>);
        } else if (etype === 22) { //序号
            return this.renderDomObj(<span>{detailProps.serialNum}</span>);
        } else if (etype === 23) { // 财务模块  发票识别
            const { jsonparam = {} } = cellObj;
            const btnTitle = jsonparam.btn_title || evalue;
            return this.renderDomObj(<FnaInvoiceIdentify ecId={`${this && this.props && this.props.ecId || ''}_FnaInvoiceIdentify@4eg3yf`} symbol={symbol}
                                                         commonParam={commonParam} evalue={btnTitle} />);
        } else if (etype === 25) {//问号说明
            const { jsonparam = {} } = cellObj;
            const msgValue = (jsonparam.value || "").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/(\r\n|\r|\n)/g, "<br/>").replace(/ /g, "&nbsp;");
            return JSComplete && this.renderDomObj(<span>
                <WeaHelpfulTip ecId={`${this && this.props && this.props.ecId || ''}_WeaHelpfulTip@tdrnso`}
                    title={msgValue}
                    placement="top"
                />
            </span>);
        } else if (etype === 26) {  //多语言标签
            const { labelInfo } = cellInfo;
            const { labelid } = cellObj.jsonparam || {};
            return this.renderDomObj(
                <span dangerouslySetInnerHTML={{ __html: `${labelInfo[labelid] || ""}` }}></span>
            );
        } else if (etype === 28 || etype === 29) {     //系统字段
            return this.renderDomObj(<SystemField ecId={`${this && this.props && this.props.ecId || ''}_SystemField@mxnixm`} cellObj={cellObj} />)
        }
        return this.renderDomObj(<span>{evalue}</span>);
    }
    convertText(str, notConverSpace = false, convertltgt = true) {
        if (str === null || typeof str === "undefined")
            return "";
        else {
            let _str = str;
            if (convertltgt)
                _str = _str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            _str = _str.replace(/(\r\n|\r|\n)/g, "</br>");
            if (!notConverSpace) {
                // 优化断行，多个空格中首个空格不转译，其余空格转&nbsp;
                // 单个空格不转换
                _str = _str.replace(/( {2,})/ig, val => " " + val.substring(1).replace(/ /ig, "&nbsp;"));
            }
            return _str;
        }

    }
    renderDomObj(content, fieldMark, swapStyle = {}) {
        const { symbol, cellAttr, cellObj, layoutStore } = this.props;
        const { fieldAttrMap, variableMap } = layoutStore;
        const etype = parseInt(cellObj.etype) || 0;
        let domProps = cellAttr ? cellAttr : {};
        domProps["className"] = `${domProps["className"] || ""} etype_${etype}_swapDiv`;
        domProps["data-cellmark"] = `${symbol}_${cellObj.id.replace(",", "_")}`;
        if (!_.isEmpty(swapStyle))
            domProps.style = { ...swapStyle, ...domProps.style || {} };
        if (etype === 2 || etype === 3) {
            const fieldid = cellObj.field || "";
            //DOM上体现下fieldid
            if (etype === 3) {
                domProps["data-fieldmark"] = fieldMark;
                domProps["className"] = `${domProps["className"] || ""} ${fieldMark}_swapDiv`;
                if (fieldAttrMap.has(fieldid)) {
                    const fieldAttr = fieldAttrMap.get(fieldid);
                    domProps["data-fieldname"] = fieldAttr.fieldname;
                    if (fieldAttr.htmltype === 4)    //check框
                        domProps.style = { ...{ display: "inline-block" }, ...domProps.style };
                }
                domProps.onClick = () => {
                    WfForm.triggerFieldAction("onclick", fieldMark)
                };
                domProps.onDoubleClick = () => {
                    WfForm.triggerFieldAction("ondbclick", fieldMark)
                };
                domProps.onMouseOver = () => {
                    WfForm.triggerFieldAction("mouseover", fieldMark)
                };
                domProps.onMouseOut = () => {
                    WfForm.triggerFieldAction("mouseout", fieldMark)
                };
            } else if (etype === 2) {
                domProps.style = { ...{ display: "inline-block" }, ...domProps.style };
            }
            //显示属性联动隐藏内容
            if (symbol.indexOf("detail_") === -1) {
                let _className = domProps["className"] || "";
                if (variableMap.get(`field${fieldid}_viewAttr`) === 4) {
                    _className += " linkage_hide";
                } else {  //多字段隐藏不rander McLayout固需要去除
                    _className = _className.replace(/linkage_hide/g, "");
                }
                domProps["className"] = _className;
            }
        }
        if (symbol.indexOf("mc_") > -1 || etype === 20 || etype === 21) {     //兼容低级模式勾选框使用span结构
            return <span {...domProps}>{content}</span>
        } else {
            return <div {...domProps}>{content}</div>
        }
    }
    renderHtmlText(content, etype) {

        const { symbol, cellAttr, cellObj } = this.props;
        let scrollStyle = etype == 5 ? { width: "100%", overflow: "auto hidden" } : {};//签字意见内容宽度超出表格宽度时，加个滚动效果
        const domProps = cellAttr ? { id: cellAttr.id, name: cellAttr.name, className: cellAttr.className, style: { ...scrollStyle, ...cellAttr.style } } : { ...scrollStyle };
        //没有内容不渲染，不占用高度
        if (!content || content == '') {
            domProps["className"] = `${domProps["className"] || ""}`.replace('span_mc ',' ').replace('span_mc_marginRight',' ');
            return <span {...domProps} ></span>
        }
        domProps["className"] = `${domProps["className"] || ""} etype_${etype}_swapDiv`;
        if (etype === 5)
            domProps["className"] = `${domProps["className"] || ""} node${cellObj.field}_swapDiv`;
        if (symbol.indexOf("mc_") > -1) {
            return <span {...domProps} dangerouslySetInnerHTML={{ __html: content === "" ? "" : content }}></span>
        } else {
            return <div {...domProps} dangerouslySetInnerHTML={{ __html: content === "" ? "" : content }}></div>
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/CellType.js